import * as React from "react";
import { cn } from "@/lib/cn";

/**
 * A label and its value, in a definition list.
 *
 * <dl>/<dt>/<dd> rather than two divs: an order detail screen is a list of
 * term-and-value pairs, and that is what the markup should say. A screen
 * reader then announces "Status: on hold" instead of two unrelated strings.
 */
export function DetailList({ children, className }: { children: React.ReactNode; className?: string }) {
  return <dl className={cn("divide-y divide-border-light", className)}>{children}</dl>;
}

export function DetailRow({
  label,
  children,
  mono,
}: {
  label: string;
  children: React.ReactNode;
  /** For codes and identifiers, where character shapes matter more than prose. */
  mono?: boolean;
}) {
  return (
    <div className="flex flex-wrap items-baseline justify-between gap-x-6 gap-y-1 px-4 py-2.5">
      <dt className="text-xs font-medium uppercase tracking-wide text-muted-foreground">{label}</dt>
      <dd className={cn("min-w-0 text-sm", mono ? "font-mono text-xs break-all" : "")}>{children}</dd>
    </div>
  );
}
